require.config({
  paths: {
    jquery: 'vendor/jquery/dist/jquery',
    angular: 'vendor/angular/angular',
    angularBootstrap: 'vendor/angular-bootstrap/ui-bootstrap-tpls',
    angularUiRouter: 'vendor/angular-ui-router/release/angular-ui-router',
    angularTouch: 'vendor/angular-touch/angular-touch',
    angularSanitize: 'vendor/angular-sanitize/angular-sanitize',
    angularUuid4: 'vendor/angular-uuid4/angular-uuid4',
    angularjsToaster: 'vendor/angularjs-toaster/toaster',
    lodash: 'vendor/lodash/dist/lodash',
    bootstrap: 'lib/bootstrap/bootstrap.min',
    modernizr: 'lib/modernizr/modernizr-custom'
  },
  shim: {
    'angular': {
      'deps': ['jquery'],
      'exports': 'angular'
    },
    'bootstrap': {
      'deps': ['jquery']
    },
    'angularBootstrap': ['angular'],
    'angularUiRouter': ['angular'],
    'angularTouch': ['angular'],
    'angularSanitize': ['angular'],
    'angularUuid4': ['angular'],
    'angularjsToaster': ['angular']
  }
});


require([
  "angular",
  "angularBootstrap",
  "angularUiRouter",
  "angularTouch",
  "angularSanitize",
  "angularUuid4",
  "angularjsToaster",
  "lodash",
  "bootstrap",
  "modernizr"
], function() {
  initApplication();
});


var initApplication = function() {
  require([
    "modules/costants-prod/module",
"modules/common/module",
"modules/login/module"
    
  ], function(
    ConstantsProdModule,
CommonModule,
LoginModule
    
  ) {
    var appName = "cliens-studioonline";
    var app = angular.module(
      appName, [
        ConstantsProdModule,
CommonModule,
LoginModule
      ]
    );

    app.constant("VERSION", "1.2.0");

    if (typeof initTemplates === 'function') {
      initTemplates();
    }

    angular.element().ready(function() {
      angular.bootstrap(document, [appName]);
    });
  });
};
define("main.prod", function(){});

